export default __webpack_public_path__ + "static/media/Rectangle-2.31436841.png";